@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.batch-details {
  min-height: 150px;
  width: 100%;
  padding: 10px;
  margin-left: 50px;
}

.info-row {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  width: auto;

  &.info {
    color: @label-batch-status--processing-first-row--text-color;
    margin-right: 10px;
  }
  &.has-error {
    flex-direction: column;
  }
}

.loading-indicator {
  width: 24px;
  height: 24px;
}

.inline {
  width: 300px;
  margin-top: 4px;
}
